import { render, staticRenderFns } from "./ContratoAssinantes.vue?vue&type=template&id=17008685&scoped=true"
import script from "./ContratoAssinantes.vue?vue&type=script&lang=js"
export * from "./ContratoAssinantes.vue?vue&type=script&lang=js"
import style0 from "./ContratoAssinantes.vue?vue&type=style&index=0&id=17008685&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17008685",
  null
  
)

export default component.exports